const STORAGE_KEY = 'zakeke-quick-search-recent';
const MAX_RECENT = 10;

export const getRecentSearches = (): string[] => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        if (!Array.isArray(parsed)) return [];
        return parsed.filter((x): x is string => typeof x === 'string' && x.trim() !== '').slice(0, MAX_RECENT);
    } catch {
        return [];
    }
};

export const addRecentSearch = (term: string): void => {
    const trimmed = term.trim();
    if (!trimmed) return;
    try {
        const existing = getRecentSearches().filter((x) => x.toLowerCase() !== trimmed.toLowerCase());
        const updated = [trimmed, ...existing].slice(0, MAX_RECENT);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
    } catch {
        // Ignore storage errors (e.g. disabled localStorage).
    }
};
